import React, { FC } from 'react';
import triggerTracking from '@blueprint/tracking';
import { FacebookColourMedium, GoogleColourMedium } from '@blueprint/icons';

import { SocialSignInWrapper, SocialSignInText } from '../../AuthModal.styles';
import { ButtonWithLoading } from 'shared/components/ButtonWithLoading';

type SocialCopy = {
    cta: string;
    facebook: string;
    google: string;
};

export type LoadingType = Partial<Record<'facebook' | 'google', boolean>>;

type SocialAuthProps = {
    isLoading?: LoadingType;
    onFacebookLogin: () => void;
    onGoogleLogin: () => void;
    copy: SocialCopy;
    type: 'signin' | 'register';
};

const SocialAuth: FC<SocialAuthProps> = ({
    onFacebookLogin,
    onGoogleLogin,
    isLoading,
    copy,
    type
}) => {
    return (
        <SocialSignInWrapper className="social-login">
            <SocialSignInText color="grey-steel" size="secondary">
                {copy.cta}
            </SocialSignInText>
            <ButtonWithLoading
                variant="secondary"
                isFullWidth
                data-testid={`${type}-google`}
                onClick={() => {
                    onGoogleLogin();
                    triggerTracking({
                        event: 'GAEvent',
                        eventCategory: type,
                        eventAction: 'click',
                        eventLabel: 'google'
                    });
                }}
                isLoading={isLoading?.google}
            >
                <GoogleColourMedium />
                {copy.google}
            </ButtonWithLoading>
            <ButtonWithLoading
                variant="secondary"
                isFullWidth
                data-testid={`${type}-facebook`}
                onClick={() => {
                    onFacebookLogin();
                    triggerTracking({
                        event: 'GAEvent',
                        eventCategory: type,
                        eventAction: 'click',
                        eventLabel: 'facebook'
                    });
                }}
                isLoading={isLoading?.facebook}
            >
                <FacebookColourMedium />
                {copy.facebook}
            </ButtonWithLoading>
        </SocialSignInWrapper>
    );
};

export default SocialAuth;
